<!-- De rand-handle is weg (finetune 2026-09-15): het paneel opent via het
     user-menu ("Applicatie-instellingen") of de mobiele toolbar; sluiten via
     de knop in de paneel-header. -->
<aside class="settings-panel" [class.is-open]="open()" role="complementary">
  <div class="settings-panel-header">
    <span class="settings-panel-title">{{ t('humanDesign.chart.controls.settingsPanelTitle') }}</span>
    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="chevron-right"
      [attr.aria-label]="t('humanDesign.chart.controls.closeSettings')"
      (click)="togglePanel()"
    ></button>
  </div>

  <div class="settings-panel-body">

    <!-- De vroegere chart-sectie (ingebouwde presets + Just Now) is weg
         (2026-08-23): charts komen enkel nog uit de chart manager; Just Now
         leeft in de shortcut-bar. -->

    <!-- 1. Visualisatie-sectie (globaal) -->
    <section class="settings-section">
      <div class="settings-section-header">
        <span class="settings-section-title">{{ t('humanDesign.chart.controls.sections.visualization') }}</span>
        <span class="settings-badge settings-badge-global">{{ t('humanDesign.chart.controls.global') }}</span>
      </div>

      @for (row of visualizationRows(); track row.key) {
        <div class="settings-labeled-row">
          <span class="settings-row-label">{{ row.label }}</span>
          <e-dropdown-menu #vizRowDropdown class="settings-dropdown" size="sm">
            <ng-template eSlot="activator">
              <button
                type="button"
                class="preset-dropdown-activator"
                aria-haspopup="menu"
                (click)="vizRowDropdown.toggleMenu()"
              >
                <span class="preset-dropdown-value">{{ selectedRowLabel(row) }}</span>
                <i eIcon icon="chevron-down"></i>
              </button>
            </ng-template>
            <ng-template eSlot="menu">
              <div class="preset-dropdown-menu">
                @for (option of row.options; track option.id) {
                  <e-dropdown-menu-item (click)="onVisualizationRowChange(row, option.id, vizRowDropdown)">
                    <span class="preset-dropdown-option" [class.preset-dropdown-option-active]="option.id === row.selectedId">
                      {{ option.label }}
                    </span>
                  </e-dropdown-menu-item>
                }
              </div>
            </ng-template>
          </e-dropdown-menu>
        </div>
      }

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.gateGraph.paletteLabel') }}</span>
        <e-dropdown-menu #gateGraphPaletteDropdown class="settings-dropdown" size="sm">
          <ng-template eSlot="activator">
            <button
              type="button"
              class="preset-dropdown-activator"
              aria-haspopup="menu"
              [attr.tooltip]="t('humanDesign.gateGraph.paletteTooltip')"
              (click)="gateGraphPaletteDropdown.toggleMenu()"
            >
              <span class="preset-dropdown-value">{{ selectedGateGraphPaletteLabel() }}</span>
              <i eIcon icon="chevron-down"></i>
            </button>
          </ng-template>
          <ng-template eSlot="menu">
            <div class="preset-dropdown-menu">
              @for (option of gateGraphPaletteOptions(); track option.id) {
                <e-dropdown-menu-item (click)="gateGraphPaletteChange.emit(option.id); gateGraphPaletteDropdown.toggleMenu(false)">
                  <span class="preset-dropdown-option" [class.preset-dropdown-option-active]="option.id === gateGraphPalette()">
                    {{ option.label }}
                  </span>
                </e-dropdown-menu-item>
              }
            </div>
          </ng-template>
        </e-dropdown-menu>
      </div>
    </section>

    <!-- 2. Interactie-sectie (globaal) -->
    <section class="settings-section">
      <div class="settings-section-header">
        <span class="settings-section-title">{{ t('humanDesign.chart.controls.sections.interaction') }}</span>
        <span class="settings-badge settings-badge-global">{{ t('humanDesign.chart.controls.global') }}</span>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.gateInfoBehavior') }}</span>
        <e-dropdown-menu #gateInfoBehaviorDropdown class="settings-dropdown" size="sm">
          <ng-template eSlot="activator">
            <button
              type="button"
              class="preset-dropdown-activator"
              aria-haspopup="menu"
              [attr.tooltip]="t('humanDesign.chart.controls.tooltips.gateInfoBehavior')"
              (click)="gateInfoBehaviorDropdown.toggleMenu()"
            >
              <span class="preset-dropdown-value">{{ selectedGateInfoOpenBehaviorLabel() }}</span>
              <i eIcon icon="chevron-down"></i>
            </button>
          </ng-template>
          <ng-template eSlot="menu">
            <div class="preset-dropdown-menu">
              @for (option of gateInfoOpenBehaviorOptions(); track option.id) {
                <e-dropdown-menu-item (click)="gateInfoOpenBehaviorChange.emit(option.id); gateInfoBehaviorDropdown.toggleMenu(false)">
                  <span class="preset-dropdown-option" [class.preset-dropdown-option-active]="option.id === gateInfoOpenBehavior()">
                    {{ option.label }}
                  </span>
                </e-dropdown-menu-item>
              }
            </div>

          </ng-template>
        </e-dropdown-menu>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.docLinkBehavior') }}</span>
        <e-dropdown-menu #docLinkBehaviorDropdown class="settings-dropdown" size="sm">
          <ng-template eSlot="activator">
            <button
              type="button"
              class="preset-dropdown-activator"
              aria-haspopup="menu"
              [attr.tooltip]="t('humanDesign.chart.controls.tooltips.docLinkBehavior')"
              (click)="docLinkBehaviorDropdown.toggleMenu()"
            >
              <span class="preset-dropdown-value">{{ selectedDocLinkOpenBehaviorLabel() }}</span>
              <i eIcon icon="chevron-down"></i>
            </button>
          </ng-template>
          <ng-template eSlot="menu">
            <div class="preset-dropdown-menu">
              @for (option of docLinkOpenBehaviorOptions(); track option.id) {
                <e-dropdown-menu-item (click)="docLinkOpenBehaviorChange.emit(option.id); docLinkBehaviorDropdown.toggleMenu(false)">
                  <span class="preset-dropdown-option" [class.preset-dropdown-option-active]="option.id === docLinkOpenBehavior()">
                    {{ option.label }}
                  </span>
                </e-dropdown-menu-item>
              }
            </div>
          </ng-template>
        </e-dropdown-menu>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.rightClick') }}</span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="bug"
          [color]="contextMenuEnabled() ? 'highlight' : 'primary-75'"
          [iconColor]="contextMenuEnabled() ? 'primary-75' : undefined"
          [tooltip]="contextMenuEnabled() ? t('humanDesign.chart.controls.tooltips.disableRightClick') : t('humanDesign.chart.controls.tooltips.enableRightClick')"
          [attr.aria-pressed]="!contextMenuEnabled()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleRightClick')"
          (click)="onContextMenuToggleClick()"
        ></button>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.channelHighlight') }}</span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="link"
          [color]="channelHighlightEnabled() ? 'primary-75' : 'highlight'"
          [iconColor]="channelHighlightEnabled() ? undefined : 'primary-75'"
          [tooltip]="channelHighlightEnabled() ? t('humanDesign.chart.controls.tooltips.channelHighlightDisable') : t('humanDesign.chart.controls.tooltips.channelHighlightEnable')"
          [attr.aria-pressed]="channelHighlightEnabled()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleChannelHighlight')"
          data-test-id="panel-channel-highlight"
          (click)="onChannelHighlightToggleClick()"
        ></button>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.dimOnHover') }}</span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="moon"
          [color]="dimOnHover() ? 'primary-75' : 'highlight'"
          [iconColor]="dimOnHover() ? undefined : 'primary-75'"
          [tooltip]="dimOnHover() ? t('humanDesign.chart.controls.tooltips.dimOnHoverDisable') : t('humanDesign.chart.controls.tooltips.dimOnHoverEnable')"
          [attr.aria-pressed]="dimOnHover()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleDimOnHover')"
          data-test-id="panel-dim-on-hover"
          (click)="dimOnHoverToggled.emit()"
        ></button>
      </div>

      <!-- Basis-paneel ↔ chart-hover (zwaar; info-popover waarschuwt, default uit). -->
      <div class="settings-labeled-row">
        <span class="settings-row-label settings-row-label--with-info">
          {{ t('humanDesign.chart.controls.rows.basicPanelChartLink') }}
          <e-info-label class="settings-info" position="top">
            <ng-template>
              <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.basicPanelChartLink') }}</div>
            </ng-template>
          </e-info-label>
        </span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="link"
          [color]="basicPanelChartLink() ? 'primary-75' : 'highlight'"
          [iconColor]="basicPanelChartLink() ? undefined : 'primary-75'"
          [tooltip]="basicPanelChartLink() ? t('humanDesign.chart.controls.tooltips.basicPanelChartLinkDisable') : t('humanDesign.chart.controls.tooltips.basicPanelChartLinkEnable')"
          [attr.aria-pressed]="basicPanelChartLink()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleBasicPanelChartLink')"
          data-test-id="panel-basic-panel-chart-link"
          (click)="basicPanelChartLinkToggled.emit()"
        ></button>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.hoverHighlightColor') }}</span>
        <div class="settings-section-row">
          @for (color of hoverHighlightColors; track color) {
            <button
              eBtn
              size="sm"
              type="button"
              class="hover-color-option"
              [color]="hoverHighlightColor() === color ? 'primary-75' : 'highlight'"
              [textColor]="hoverHighlightColor() === color ? undefined : 'primary-75'"
              [tooltip]="t('humanDesign.chart.controls.tooltips.hoverHighlightColor.' + color)"
              [attr.aria-pressed]="hoverHighlightColor() === color"
              [attr.data-test-id]="'panel-hover-color-' + color"
              (click)="hoverHighlightColorChange.emit(color)"
            >
              <span class="hover-color-swatch" [class.hover-color-swatch--green]="color === 'green'" aria-hidden="true"></span>
              {{ t('humanDesign.chart.controls.hoverHighlightColors.' + color) }}
            </button>
          }
        </div>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.highlightGatePieces') }}</span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="vector-square"
          [color]="highlightGatePieces() ? 'primary-75' : 'highlight'"
          [iconColor]="highlightGatePieces() ? undefined : 'primary-75'"
          [tooltip]="highlightGatePieces() ? t('humanDesign.chart.controls.tooltips.highlightGatePiecesDisable') : t('humanDesign.chart.controls.tooltips.highlightGatePiecesEnable')"
          [attr.aria-pressed]="highlightGatePieces()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleHighlightGatePieces')"
          data-test-id="panel-highlight-gate-pieces"
          (click)="highlightGatePiecesToggled.emit()"
        ></button>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.dimOneSideOnly') }}</span>
        <!-- Enkel zinvol wanneer "dimmen bij hover" aan staat; anders dimt er sowieso niets. -->
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="arrows-left-right"
          [disabled]="!dimOnHover()"
          [color]="dimOneSideOnly() ? 'primary-75' : 'highlight'"
          [iconColor]="dimOneSideOnly() ? undefined : 'primary-75'"
          [tooltip]="!dimOnHover() ? t('humanDesign.chart.controls.tooltips.dimOneSideOnlyRequiresDim') : dimOneSideOnly() ? t('humanDesign.chart.controls.tooltips.dimOneSideOnlyDisable') : t('humanDesign.chart.controls.tooltips.dimOneSideOnlyEnable')"
          [attr.aria-pressed]="dimOneSideOnly()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleDimOneSideOnly')"
          data-test-id="panel-dim-one-side-only"
          (click)="dimOneSideOnlyToggled.emit()"
        ></button>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.keynotesAtHoverOnly') }}</span>
        <!-- Weergave omgedraaid t.o.v. de onderliggende `keynotesAtHoverOnly`-signal:
             "aan" = keynotes tegelijk in chart én grid tonen (= keynotesAtHoverOnly false). -->
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="eye"
          [color]="!keynotesAtHoverOnly() ? 'primary-75' : 'highlight'"
          [iconColor]="!keynotesAtHoverOnly() ? undefined : 'primary-75'"
          [tooltip]="keynotesAtHoverOnly() ? t('humanDesign.chart.controls.tooltips.enableLinkedKeynotes') : t('humanDesign.chart.controls.tooltips.enableHoverOnlyKeynotes')"
          [attr.aria-pressed]="!keynotesAtHoverOnly()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleKeynotesAtHoverOnly')"
          data-test-id="panel-keynotes-at-hover-only"
          (click)="keynotesAtHoverOnlyToggled.emit()"
        ></button>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.showBothCenterStates') }}</span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="circle-half-stroke"
          [color]="showBothCenterStateSections() ? 'primary-75' : 'highlight'"
          [iconColor]="showBothCenterStateSections() ? undefined : 'primary-75'"
          [tooltip]="showBothCenterStateSections() ? t('humanDesign.chart.controls.tooltips.showApplicableCenterStateOnly') : t('humanDesign.chart.controls.tooltips.showBothCenterStates')"
          [attr.aria-pressed]="showBothCenterStateSections()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleBothCenterStates')"
          data-test-id="panel-show-both-center-states"
          (click)="showBothCenterStateSectionsToggled.emit()"
        ></button>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.gateInfoSeparateDock') }}</span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="table-columns"
          [color]="gateInfoFromChannelSeparateToDock() ? 'primary-75' : 'highlight'"
          [iconColor]="gateInfoFromChannelSeparateToDock() ? undefined : 'primary-75'"
          [tooltip]="gateInfoFromChannelSeparateToDock() ? t('humanDesign.chart.controls.tooltips.gateInfoSeparateDockOn') : t('humanDesign.chart.controls.tooltips.gateInfoSeparateDockOff')"
          [attr.aria-pressed]="gateInfoFromChannelSeparateToDock()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleGateInfoSeparateDock')"
          data-test-id="panel-gate-info-from-channel-separate-dock"
          (click)="onGateInfoFromChannelSeparateToDockToggleClick()"
        ></button>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.buttonSize') }}</span>
        <div class="settings-section-row">
          <button
            eBtn
            size="sm"
            squared
            type="button"
            [color]="shortcutButtonSize() === 'sm' ? 'primary-75' : 'highlight'"
            [textColor]="shortcutButtonSize() === 'sm' ? undefined : 'primary-75'"
            [tooltip]="t('humanDesign.chart.controls.tooltips.buttonSizeSm')"
            [attr.aria-pressed]="shortcutButtonSize() === 'sm'"
            data-test-id="panel-shortcut-size-sm"
            (click)="shortcutButtonSizeChange.emit('sm')"
          >SM</button>

          <button
            eBtn
            size="sm"
            squared
            type="button"
            [color]="shortcutButtonSize() === 'xs' ? 'primary-75' : 'highlight'"
            [textColor]="shortcutButtonSize() === 'xs' ? undefined : 'primary-75'"
            [tooltip]="t('humanDesign.chart.controls.tooltips.buttonSizeXs')"
            [attr.aria-pressed]="shortcutButtonSize() === 'xs'"
            data-test-id="panel-shortcut-size-xs"
            (click)="shortcutButtonSizeChange.emit('xs')"
          >XS</button>
        </div>
      </div>

      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.includeNonHdFeatures') }}</span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="plus"
          [color]="includeNonHdFeatures() ? 'primary-75' : 'highlight'"
          [iconColor]="includeNonHdFeatures() ? undefined : 'primary-75'"
          [tooltip]="t('humanDesign.chart.controls.tooltips.includeNonHdFeatures')"
          [attr.aria-pressed]="includeNonHdFeatures()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleIncludeNonHdFeatures')"
          data-test-id="panel-include-non-hd-features"
          (click)="includeNonHdFeaturesToggled.emit()"
        ></button>
      </div>

      <!-- Scope van de "gelijkaardige charts"-matchlijsten: hele bibliotheek of enkel gerelateerde charts. -->
      <div class="settings-labeled-row">
        <span class="settings-row-label">{{ t('humanDesign.chart.controls.rows.chartMatchScope') }}</span>
        <div class="settings-section-row">
          <button
            eBtn
            size="sm"
            squared
            type="button"
            icon="books"
            [color]="chartMatchScope() === 'library' ? 'primary-75' : 'highlight'"
            [iconColor]="chartMatchScope() === 'library' ? undefined : 'primary-75'"
            [tooltip]="t('humanDesign.chart.controls.tooltips.chartMatchScopeLibrary')"
            [attr.aria-pressed]="chartMatchScope() === 'library'"
            data-test-id="panel-chart-match-scope-library"
            (click)="chartMatchScopeChange.emit('library')"
          ></button>

          <button
            eBtn
            size="sm"
            squared
            type="button"
            icon="link"
            [color]="chartMatchScope() === 'related' ? 'primary-75' : 'highlight'"
            [iconColor]="chartMatchScope() === 'related' ? undefined : 'primary-75'"
            [tooltip]="t('humanDesign.chart.controls.tooltips.chartMatchScopeRelated')"
            [attr.aria-pressed]="chartMatchScope() === 'related'"
            data-test-id="panel-chart-match-scope-related"
            (click)="chartMatchScopeChange.emit('related')"
          ></button>
        </div>
      </div>
    </section>

    <!-- 3. Taal & acties-sectie (globaal) -->
    <section class="settings-section">
      <div class="settings-section-header">
        <span class="settings-section-title">{{ t('humanDesign.chart.controls.sections.languageActions') }}</span>
        <span class="settings-badge settings-badge-global">{{ t('humanDesign.chart.controls.global') }}</span>
      </div>
      <div class="settings-section-row">
        <e-dropdown-menu #contentLangDropdown class="settings-dropdown" size="sm">
          <ng-template eSlot="activator">
            <button
              type="button"
              class="preset-dropdown-activator"
              aria-haspopup="menu"
              [attr.aria-label]="t('humanDesign.chart.controls.prefixes.language', { name: selectedContentLangLabel() })"
              [attr.tooltip]="t('humanDesign.chart.controls.tooltips.contentLanguage')"
              (click)="contentLangDropdown.toggleMenu()"
            >
              <i eIcon icon="globe"></i>
              <span class="preset-dropdown-value">{{ selectedContentLangLabel() }}</span>
              <i eIcon icon="chevron-down"></i>
            </button>
          </ng-template>
          <ng-template eSlot="menu">
            <div class="preset-dropdown-menu">
              @for (option of contentLanguageOptions; track option.id) {
                <e-dropdown-menu-item (click)="onContentLanguageChange(option.id, contentLangDropdown)">
                  <span class="preset-dropdown-option" [class.preset-dropdown-option-active]="option.id === selectedContentLang()">
                    {{ option.label }}
                  </span>
                </e-dropdown-menu-item>
              }
            </div>
          </ng-template>
        </e-dropdown-menu>

        @if (showPrint()) {
          <button
            eBtn
            size="sm"
            squared
            type="button"
            color="highlight"
            icon="print"
            iconColor="primary-75"
            [tooltip]="t('humanDesign.chart.controls.tooltips.print')"
            data-test-id="panel-print"
            (click)="printRequested.emit()"
          ></button>
        }
      </div>
    </section>

    <!-- 4. Community-content: opt-in voor teksten van communityleden (globaal). -->
    <section class="settings-section">
      <div class="settings-section-header">
        <span class="settings-section-title">{{ t('humanDesign.chart.controls.sections.community') }}</span>
        <span class="settings-badge settings-badge-global">{{ t('humanDesign.chart.controls.global') }}</span>
      </div>
      <div class="settings-labeled-row">
        <span class="settings-row-label settings-row-label--with-info">
          {{ t('humanDesign.chart.controls.rows.communityContent') }}
          <e-info-label class="settings-info" position="top">
            <ng-template>
              <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.communityContent') }}</div>
            </ng-template>
          </e-info-label>
        </span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="users"
          [color]="communityContentEnabled() ? 'primary-75' : 'highlight'"
          [iconColor]="communityContentEnabled() ? undefined : 'primary-75'"
          [tooltip]="communityContentEnabled() ? t('humanDesign.chart.controls.tooltips.communityContentDisable') : t('humanDesign.chart.controls.tooltips.communityContentEnable')"
          [attr.aria-pressed]="communityContentEnabled()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleCommunityContent')"
          data-test-id="panel-community-content"
          (click)="communityContentEnabledToggled.emit()"
        ></button>
      </div>
    </section>

    <!-- 5. Lijnteksten: de bronnen van de I'Ching-lijnteksten, elk los aan/uit
         en vrij te combineren (globaal). Default = de bestaande weergave: Ra aan,
         Chetan uit, eigen teksten uit. -->
    <section class="settings-section" data-test-id="panel-line-texts-section">
      <div class="settings-section-header">
        <span class="settings-section-title">{{ t('humanDesign.chart.controls.sections.lineTexts') }}</span>
        <span class="settings-badge settings-badge-global">{{ t('humanDesign.chart.controls.global') }}</span>
      </div>
      <div class="settings-labeled-row">
        <span class="settings-row-label settings-row-label--with-info">
          {{ t('humanDesign.chart.controls.rows.raLineTexts') }}
          <e-info-label class="settings-info" position="top">
            <ng-template>
              <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.raLineTexts') }}</div>
            </ng-template>
          </e-info-label>
        </span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="book"
          [color]="raLineTextsEnabled() ? 'primary-75' : 'highlight'"
          [iconColor]="raLineTextsEnabled() ? undefined : 'primary-75'"
          [tooltip]="raLineTextsEnabled() ? t('humanDesign.chart.controls.tooltips.raLineTextsDisable') : t('humanDesign.chart.controls.tooltips.raLineTextsEnable')"
          [attr.aria-pressed]="raLineTextsEnabled()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleRaLineTexts')"
          data-test-id="panel-ra-line-texts"
          (click)="raLineTextsEnabledToggled.emit()"
        ></button>
      </div>

      <!-- Alternatieve I Tjing-interpretaties (The Book of Lines, Chetan Parkyn)
           als extra regel bij de exaltation/detriment van elke lijn; stond tot
           de eigen lijnteksten bij de community-content (Steven 2026-10-10). -->
      <div class="settings-labeled-row">
        <span class="settings-row-label settings-row-label--with-info">
          {{ t('humanDesign.chart.controls.rows.alternativeIChing') }}
          <e-info-label class="settings-info" position="top">
            <ng-template>
              <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.alternativeIChing') }}</div>
            </ng-template>
          </e-info-label>
        </span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="yin-yang"
          [color]="alternativeIChingEnabled() ? 'primary-75' : 'highlight'"
          [iconColor]="alternativeIChingEnabled() ? undefined : 'primary-75'"
          [tooltip]="alternativeIChingEnabled() ? t('humanDesign.chart.controls.tooltips.alternativeIChingDisable') : t('humanDesign.chart.controls.tooltips.alternativeIChingEnable')"
          [attr.aria-pressed]="alternativeIChingEnabled()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleAlternativeIChing')"
          data-test-id="panel-alternative-iching"
          (click)="alternativeIChingEnabledToggled.emit()"
        ></button>
      </div>

      <!-- Eigen lijnteksten (Mechanics in Motion): eigen lijnbeschrijving en
           eigen exaltation-/detriment-regel, herkenbaar aan ◆ en amber-inkt. -->
      <div class="settings-labeled-row">
        <span class="settings-row-label settings-row-label--with-info">
          {{ t('humanDesign.chart.controls.rows.ownLineTexts') }}
          <e-info-label class="settings-info" position="top">
            <ng-template>
              <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.ownLineTexts') }}</div>
            </ng-template>
          </e-info-label>
        </span>
        <button
          eBtn
          size="sm"
          squared
          type="button"
          icon="pen-nib"
          [color]="ownLineTextsEnabled() ? 'primary-75' : 'highlight'"
          [iconColor]="ownLineTextsEnabled() ? undefined : 'primary-75'"
          [tooltip]="ownLineTextsEnabled() ? t('humanDesign.chart.controls.tooltips.ownLineTextsDisable') : t('humanDesign.chart.controls.tooltips.ownLineTextsEnable')"
          [attr.aria-pressed]="ownLineTextsEnabled()"
          [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleOwnLineTexts')"
          data-test-id="panel-own-line-texts"
          (click)="ownLineTextsEnabledToggled.emit()"
        ></button>
      </div>

      <!-- Reviewoverzicht van de eigen lijnteksten: enkel met de UPAM-feature
           ReviewLineTexts (goedkeuren/herschrijven gebeurt bij de tekst zelf). -->
      @if (lineTextReviewFeatureGranted()) {
        <div class="settings-labeled-row">
          <span class="settings-row-label settings-row-label--with-info">
            {{ t('humanDesign.chart.controls.rows.lineTextReview') }}
            <e-info-label class="settings-info" position="top">
              <ng-template>
                <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.lineTextReview') }}</div>
              </ng-template>
            </e-info-label>
          </span>
          <button
            eBtn
            size="sm"
            squared
            type="button"
            icon="clipboard-check"
            color="highlight"
            iconColor="primary-75"
            [tooltip]="t('humanDesign.chart.controls.tooltips.lineTextReview')"
            [attr.aria-label]="t('humanDesign.chart.controls.aria.openLineTextReview')"
            data-test-id="panel-line-text-review"
            (click)="lineTextReviewRequested.emit()"
          ></button>
        </div>
      }
    </section>

    <!-- 6. Classic I Ching: alleen zichtbaar met de UPAM-feature (globaal). -->
    @if (classicIChingFeatureGranted()) {
      <section class="settings-section">
        <div class="settings-section-header">
          <span class="settings-section-title">{{ t('humanDesign.chart.controls.sections.classicIChing') }}</span>
          <span class="settings-badge settings-badge-global">{{ t('humanDesign.chart.controls.global') }}</span>
        </div>
        <div class="settings-labeled-row">
          <span class="settings-row-label settings-row-label--with-info">
            {{ t('humanDesign.chart.controls.rows.classicIChing') }}
            <e-info-label class="settings-info" position="top">
              <ng-template>
                <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.classicIChing') }}</div>
              </ng-template>
            </e-info-label>
          </span>
          <button
            eBtn
            size="sm"
            squared
            type="button"
            icon="scroll-old"
            [color]="classicIChingEnabled() ? 'primary-75' : 'highlight'"
            [iconColor]="classicIChingEnabled() ? undefined : 'primary-75'"
            [tooltip]="classicIChingEnabled() ? t('humanDesign.chart.controls.tooltips.classicIChingDisable') : t('humanDesign.chart.controls.tooltips.classicIChingEnable')"
            [attr.aria-pressed]="classicIChingEnabled()"
            [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleClassicIChing')"
            data-test-id="panel-classic-iching"
            (click)="classicIChingEnabledToggled.emit()"
          ></button>
        </div>
        <!-- Doorklikiconen in de HD-schermen (HexWave-ronde); zonder Classic I Ching uitgeschakeld. -->
        <div class="settings-labeled-row">
          <span class="settings-row-label settings-row-label--with-info">
            {{ t('humanDesign.chart.controls.rows.classicIChingIconsChart') }}
            <e-info-label class="settings-info" position="top">
              <ng-template>
                <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.classicIChingIconsChart') }}</div>
              </ng-template>
            </e-info-label>
          </span>
          <button
            eBtn
            size="sm"
            squared
            type="button"
            icon="chart-simple"
            [color]="classicIChingIconsChart() ? 'primary-75' : 'highlight'"
            [iconColor]="classicIChingIconsChart() ? undefined : 'primary-75'"
            [tooltip]="classicIChingIconsChart() ? t('humanDesign.chart.controls.tooltips.classicIChingIconsChartDisable') : t('humanDesign.chart.controls.tooltips.classicIChingIconsChartEnable')"
            [disabled]="!classicIChingEnabled()"
            [attr.aria-pressed]="classicIChingIconsChart()"
            [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleClassicIChingIconsChart')"
            data-test-id="panel-classic-iching-icons-chart"
            (click)="classicIChingIconsChartToggled.emit()"
          ></button>
        </div>
        <div class="settings-labeled-row">
          <span class="settings-row-label settings-row-label--with-info">
            {{ t('humanDesign.chart.controls.rows.classicIChingIconsTransits') }}
            <e-info-label class="settings-info" position="top">
              <ng-template>
                <div class="settings-info-popover">{{ t('humanDesign.chart.controls.info.classicIChingIconsTransits') }}</div>
              </ng-template>
            </e-info-label>
          </span>
          <button
            eBtn
            size="sm"
            squared
            type="button"
            icon="calendar-days"
            [color]="classicIChingIconsTransits() ? 'primary-75' : 'highlight'"
            [iconColor]="classicIChingIconsTransits() ? undefined : 'primary-75'"
            [tooltip]="classicIChingIconsTransits() ? t('humanDesign.chart.controls.tooltips.classicIChingIconsTransitsDisable') : t('humanDesign.chart.controls.tooltips.classicIChingIconsTransitsEnable')"
            [disabled]="!classicIChingEnabled()"
            [attr.aria-pressed]="classicIChingIconsTransits()"
            [attr.aria-label]="t('humanDesign.chart.controls.aria.toggleClassicIChingIconsTransits')"
            data-test-id="panel-classic-iching-icons-transits"
            (click)="classicIChingIconsTransitsToggled.emit()"
          ></button>
        </div>
      </section>
    }

    <!-- 6. Onderaan: alle settings terug naar de app-defaults (fabrieksinstellingen). -->
    <section class="settings-section settings-section--reset">
      <button
        eBtn
        size="sm"
        type="button"
        color="highlight"
        icon="arrow-rotate-left"
        class="settings-reset-button"
        [tooltip]="t('humanDesign.chart.controls.tooltips.resetDefaults')"
        data-test-id="panel-reset-defaults"
        (click)="resetToDefaultsRequested.emit()"
      >{{ t('humanDesign.chart.controls.resetDefaults') }}</button>
    </section>

  </div>
</aside>
